import $ from "jquery";

// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from '/node_modules/swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

// import Swiper and modules styles


$(function () {

    $.fn.sliderAcfGallery = function () {

        new Swiper(this[0], {
            slidesPerView: 1,
            spaceBetween: 5,
            loop: true,
            autoplay: {
                delay: 5000,
            },
            navigation: {
                nextEl: ".swiper-button-next", 
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                992: {
                    slidesPerView: 4,
                    spaceBetween: 0
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
            },
        });
    
    };

});